import { render, staticRenderFns } from "./BtnInserirEvento.vue?vue&type=template&id=265a74ef"
import script from "./BtnInserirEvento.vue?vue&type=script&lang=js"
export * from "./BtnInserirEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports